export default __webpack_public_path__ + "static/media/orange-couch.82f130cc.png";